module.exports = __webpack_public_path__ + "static/media/180M-logo.03931daa.png";